module.exports = __webpack_public_path__ + "img/hej-en.6aae0b42.png";